import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ContentFilterItem_ArticleContentType_Fragment = { id: string, name: string };

export type ContentFilterItem_BaseResourceSchema_Fragment = { id: string, name: string };

export type ContentFilterItem_CheckinType_Fragment = { id: string, name: string };

export type ContentFilterItem_CourseContentType_Fragment = { id: string, name: string };

export type ContentFilterItem_ExerciseType_Fragment = { id: string, name: string };

export type ContentFilterItem_ExternalContentType_Fragment = { id: string, name: string };

export type ContentFilterItem_ExternalEventContentType_Fragment = { id: string, name: string };

export type ContentFilterItem_HomeworkType_Fragment = { id: string, name: string };

export type ContentFilterItem_KnowledgeAssetContentType_Fragment = { id: string, name: string };

export type ContentFilterItem_LiveEventContentType_Fragment = { id: string, name: string };

export type ContentFilterItem_MicroLearningContentType_Fragment = { id: string, name: string };

export type ContentFilterItem_OfflineEventContentType_Fragment = { id: string, name: string };

export type ContentFilterItem_PathContentType_Fragment = { id: string, name: string };

export type ContentFilterItem_QuizContentType_Fragment = { id: string, name: string };

export type ContentFilterItem_RecurringExternalEventContentType_Fragment = { id: string, name: string };

export type ContentFilterItem_RecurringLiveEventContentType_Fragment = { id: string, name: string };

export type ContentFilterItem_RecurringOfflineEventContentType_Fragment = { id: string, name: string };

export type ContentFilterItem_RoleplayContentType_Fragment = { id: string, name: string };

export type ContentFilterItem_ScormContentType_Fragment = { id: string, name: string };

export type ContentFilterItem_SurveyContentType_Fragment = { id: string, name: string };

export type ContentFilterItem_TaskContentType_Fragment = { id: string, name: string };

export type ContentFilterItemFragment = ContentFilterItem_ArticleContentType_Fragment | ContentFilterItem_BaseResourceSchema_Fragment | ContentFilterItem_CheckinType_Fragment | ContentFilterItem_CourseContentType_Fragment | ContentFilterItem_ExerciseType_Fragment | ContentFilterItem_ExternalContentType_Fragment | ContentFilterItem_ExternalEventContentType_Fragment | ContentFilterItem_HomeworkType_Fragment | ContentFilterItem_KnowledgeAssetContentType_Fragment | ContentFilterItem_LiveEventContentType_Fragment | ContentFilterItem_MicroLearningContentType_Fragment | ContentFilterItem_OfflineEventContentType_Fragment | ContentFilterItem_PathContentType_Fragment | ContentFilterItem_QuizContentType_Fragment | ContentFilterItem_RecurringExternalEventContentType_Fragment | ContentFilterItem_RecurringLiveEventContentType_Fragment | ContentFilterItem_RecurringOfflineEventContentType_Fragment | ContentFilterItem_RoleplayContentType_Fragment | ContentFilterItem_ScormContentType_Fragment | ContentFilterItem_SurveyContentType_Fragment | ContentFilterItem_TaskContentType_Fragment;


export type ContentFilterItemFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type ContentFilterQueryVariables = Types.Exact<{
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
  filters: Types.ContentFilters;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
}>;


export type ContentFilterQuery = { contents: { totalCount: number, pageInfo?: { hasNextPage?: boolean | null, endCursor?: string | null } | null, edges?: Array<{ node: { __typename: 'ArticleContentType', id: string, name: string } | { __typename: 'BaseResourceSchema', id: string, name: string } | { __typename: 'CheckinType', id: string, name: string } | { __typename: 'CourseContentType', id: string, name: string } | { __typename: 'ExerciseType', id: string, name: string } | { __typename: 'ExternalContentType', id: string, name: string } | { __typename: 'ExternalEventContentType', id: string, name: string } | { __typename: 'HomeworkType', id: string, name: string } | { __typename: 'KnowledgeAssetContentType', id: string, name: string } | { __typename: 'LiveEventContentType', id: string, name: string } | { __typename: 'MicroLearningContentType', id: string, name: string } | { __typename: 'OfflineEventContentType', id: string, name: string } | { __typename: 'PathContentType', id: string, name: string } | { __typename: 'QuizContentType', id: string, name: string } | { __typename: 'RecurringExternalEventContentType', id: string, name: string } | { __typename: 'RecurringLiveEventContentType', id: string, name: string } | { __typename: 'RecurringOfflineEventContentType', id: string, name: string } | { __typename: 'RoleplayContentType', id: string, name: string } | { __typename: 'ScormContentType', id: string, name: string } | { __typename: 'SurveyContentType', id: string, name: string } | { __typename: 'TaskContentType', id: string, name: string } }> | null } };

export const ContentFilterItemFragmentDoc = /*#__PURE__*/ gql`
    fragment ContentFilterItem on ContentEntity {
  ... on PathContentType {
    id
    name
  }
  ... on TaskContentType {
    id
    name
  }
  ... on CourseContentType {
    id
    name
  }
  ... on CheckinType {
    id
    name
  }
  ... on BaseResourceSchema {
    id
    name
  }
  ... on HomeworkType {
    id
    name
  }
  ... on ExerciseType {
    id
    name
  }
  ... on QuizContentType {
    id
    name
  }
  ... on ExternalContentType {
    id
    name
  }
  ... on ArticleContentType {
    id
    name
  }
  ... on SurveyContentType {
    id
    name
  }
  ... on ScormContentType {
    id
    name
  }
  ... on LiveEventContentType {
    id
    name
  }
  ... on OfflineEventContentType {
    id
    name
  }
  ... on ExternalEventContentType {
    id
    name
  }
  ... on RecurringLiveEventContentType {
    id
    name
  }
  ... on RecurringExternalEventContentType {
    id
    name
  }
  ... on RecurringOfflineEventContentType {
    id
    name
  }
  ... on KnowledgeAssetContentType {
    id
    name
  }
  ... on MicroLearningContentType {
    id
    name
  }
  ... on RoleplayContentType {
    id
    name
  }
}
    `;
export const ContentFilterDocument = /*#__PURE__*/ gql`
    query contentFilter($sort: [SortType!], $filters: ContentFilters!, $after: String, $first: Float) {
  contents(filters: $filters, sort: $sort, first: $first, after: $after) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        __typename
        ...ContentFilterItem
      }
    }
  }
}
    ${ContentFilterItemFragmentDoc}`;

export function useContentFilterQuery(options: Omit<Urql.UseQueryArgs<ContentFilterQueryVariables>, 'query'>) {
  return Urql.useQuery<ContentFilterQuery, ContentFilterQueryVariables>({ query: ContentFilterDocument, ...options });
};